<template>
    <div>
        <div class="d-lg-block d-none">
            <div class="container">
                <div class="row my-4">
                    <div class="col-12">
                        <h1 class="text-3xl" v-html="$t('Dine <br><strong>meldinger</strong>')"></h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-primary-darkest text-white d-lg-none mb-2" :class="{'d-block': !hasActiveConversation, 'd-none': hasActiveConversation}">
            <div class="row py-4 mt-0 no-gutters">
                <div class="col-12">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 mb-4">
                                <div @click="navigateBack" class="cursor-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="nav-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                                    </svg>
                                </div>
                            </div>
                            <div class="col-12">
                                <h1 class="text-3xl" v-html="$t('Dine <br><strong>meldinger</strong>')"></h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-lg container-fluid p-0 p-lg-1">
            <div class="row no-gutters">
                <div class="col-lg-4 col-12">
                    <ConversationList></ConversationList>
                </div>
                <div class="col-lg-8 col-12">
                    <Conversation></Conversation>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import Store from '../../state/chatStore';
import Conversation from './Conversation.vue';
import ConversationList from './ConversationList.vue';

const hasActiveConversation = computed(() => Store.getActiveConversation() !== null);

const navigateBack = () => {
    location.replace('/');
};
</script>